module.exports = __webpack_public_path__ + "img/star-03.19bae1e8.svg";